import { memo } from "react";

import { countries } from "countries-list";
import { Tooltip, Typography } from "neetoui";

const SingleValue = ({ countryCode, showEmoji = false, ...otherProps }) => {
  if (!showEmoji) return null;

  const countryData = countries[countryCode];

  return (
    <Tooltip content={countryData?.name}>
      <Typography
        className="neeto-molecules-phone-number-input__flag cursor-pointer text-center text-xl"
        style="body2"
        {...otherProps}
      >
        {countryData?.emoji}
      </Typography>
    </Tooltip>
  );
};

export default memo(SingleValue);
